import {
    SignalInfo,
    ApplicationType,
    lazyPostPersonalizationUsageSignals,
} from 'owa-personalization';

export default async function postPersonalizationUsageSignals(
    postiveSignals: SignalInfo[],
    negativeSignals: SignalInfo[],
    applicationType: ApplicationType,
    featureName: string
) {
    await lazyPostPersonalizationUsageSignals.importAndExecute(
        postiveSignals,
        negativeSignals,
        applicationType,
        featureName
    );
}
